import { render, staticRenderFns } from "./A-1-3_AboutUs_PartnerEndorsement.vue?vue&type=template&id=94b99e0c&"
import script from "./A-1-3_AboutUs_PartnerEndorsement.vue?vue&type=script&lang=js&"
export * from "./A-1-3_AboutUs_PartnerEndorsement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports